import { render, staticRenderFns } from "./RevenueStreamsTable.vue?vue&type=template&id=3a89a9a4&scoped=true"
import script from "./RevenueStreamsTable.vue?vue&type=script&lang=js"
export * from "./RevenueStreamsTable.vue?vue&type=script&lang=js"
import style0 from "./RevenueStreamsTable.vue?vue&type=style&index=0&id=3a89a9a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a89a9a4",
  null
  
)

export default component.exports